var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.steps && _vm.steps.length
    ? _c("div", { staticClass: "helpSteps" }, [
        _c("div", { staticClass: "helpSteps_header" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("h3", { staticClass: "helpSteps_title" }, [
            _vm._v(_vm._s(_vm.title)),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "ol",
          { staticClass: "helpSteps_steps" },
          _vm._l(_vm.steps, function (step, index) {
            return _c("li", { key: index, staticClass: "helpSteps_step" }, [
              step.title ? _c("h4", [_vm._v(_vm._s(step.title))]) : _vm._e(),
              _vm._v(" "),
              step.content
                ? _c("div", {
                    staticClass: "helpSteps_copy",
                    domProps: { innerHTML: _vm._s(step.content) },
                  })
                : _vm._e(),
            ])
          }),
          0
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "helpSteps_header_icon" }, [
      _c("i", { staticClass: "fa fa-info-circle" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }